import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/notifications");
      setCount(data.unread || 0);
    } catch (_e) { /* ignore */ }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    refresh();
    const id = setInterval(refresh, 25000);
    return () => clearInterval(id);
  }, [user, refresh]);

  if (!user) return null;

  return (
    <Link
      to="/notifications"
      data-testid="notification-bell"
      className="relative h-9 w-9 rounded-full grid place-items-center hover:bg-zinc-100 transition"
      aria-label="Notifications — الإشعارات"
    >
      <Bell className="h-4.5 w-4.5 text-zinc-700" aria-hidden="true" />
      {count > 0 && (
        <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-emerald-600 text-white text-[10px] font-bold grid place-items-center px-1">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </Link>
  );
}
